fx.ns("desktop.book.edition", class CreateAlbum extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;

        this.showEffect = "hslidein";
        this.hideEffect = "hslideout";
        
	}

	create()
	{
       	this.backContainer = new fx.components.Box();
		this.backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
		let text = new fx.components.Text({text : fx.text("Revenir"), className : "button-label link right-label"});
		this.backContainer.addChild(this.backButton, {width:40, height:40, left : 0, top : 0})
		this.backContainer.addChild(text, {width: 150, height : 20, top : 10, left : 40})
		this.addChild( this.backContainer, {top : 15, left : 15, width:150, height:40});

		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").splashPhoto), {width:260, height : 260, top : 0, left : "center"});

		this.title = new fx.components.Text({text :fx.text("Je vais vous créer un magnifique album !"), className : "title center"});
		box.addChild(this.title, {width:"100%", height : 40, top : 280, left : "center"});

        this.okButton = new fx.components.Button({label : fx.text("C'est parti"), icon : fx.get("assets").arrowNext, type : "filled", className : "create"});
        box.addChild(this.okButton, {width:300, height : 40, top : 320, left : "center"});
        
		this.addChild(box, { width : 500, height : 400, top : "center", left : "center"});

	}

    onReady()
    {
        super.onReady();

        this.on("click", this._onExit, this.backContainer);
        this.on("click", this._onCreate, this.okButton);
        
    }

    _onExit()
    {
		this.hideEffect = "hslideout";

        this.data.event("show-editor");
    }

    _onCreate()
    {
        this.data.event("next-step");
    }

    

});

	